var map = {
	"./99/act_tag_left-99.png": 65010,
	"./99/act_tag_right-99.png": 92402,
	"./99/map/east.png": 33939,
	"./99/map/east_north_east.png": 83686,
	"./99/map/east_south_east.png": 64229,
	"./99/map/merchant.png": 37645,
	"./99/map/north.png": 88718,
	"./99/map/north_east.png": 38550,
	"./99/map/north_north_east.png": 55860,
	"./99/map/north_north_west.png": 91679,
	"./99/map/north_west.png": 96606,
	"./99/map/south.png": 97257,
	"./99/map/south_east.png": 30369,
	"./99/map/south_south_east.png": 28739,
	"./99/map/south_south_west.png": 46611,
	"./99/map/south_west.png": 54289,
	"./99/map/west.png": 64527,
	"./99/map/west_north_west.png": 50253,
	"./99/map/west_south_west.png": 49839,
	"./99/tag_left-99.png": 88114,
	"./default_bg.png": 80546,
	"./default_img.png": 67058,
	"./default_img1.png": 53077,
	"./didi/act_tag_left.png": 35575,
	"./didi/act_tag_right.png": 51937,
	"./didi/address_icon.png": 54994,
	"./didi/app_logo.png": 50850,
	"./didi/cardStatus/status_1.png": 26871,
	"./didi/cardStatus/status_2.png": 45392,
	"./didi/cardStatus/status_3.png": 54714,
	"./didi/cardStatus/status_4.png": 36995,
	"./didi/cardStatus/status_5.png": 71037,
	"./didi/cartClose.png": 48776,
	"./didi/cartOpen.png": 93080,
	"./didi/coupon-icon.png": 49751,
	"./didi/coupon/couponBagIcon.png": 24872,
	"./didi/entrega_err.png": 28097,
	"./didi/map/customer.png": 17485,
	"./didi/map/east.png": 95545,
	"./didi/map/east_north_east.png": 70334,
	"./didi/map/east_south_east.png": 29068,
	"./didi/map/entrega-bubble.png": 97041,
	"./didi/map/entrega-c1.png": 98686,
	"./didi/map/entrega-c2-99.png": 8963,
	"./didi/map/entrega-c2.png": 77227,
	"./didi/map/merchant.png": 76200,
	"./didi/map/north.png": 44982,
	"./didi/map/north_east.png": 7613,
	"./didi/map/north_north_east.png": 87566,
	"./didi/map/north_north_west.png": 88382,
	"./didi/map/north_west.png": 65919,
	"./didi/map/south.png": 26225,
	"./didi/map/south_east.png": 51605,
	"./didi/map/south_south_east.png": 46474,
	"./didi/map/south_south_west.png": 93755,
	"./didi/map/south_west.png": 42736,
	"./didi/map/west.png": 74818,
	"./didi/map/west_north_west.png": 47924,
	"./didi/map/west_south_west.png": 88465,
	"./didi/map_bg_icon.png": 31153,
	"./didi/new_no_coupon.png": 94821,
	"./didi/no-data_address.png": 65968,
	"./didi/no_network.png": 30793,
	"./didi/no_recent_order.png": 29336,
	"./didi/no_result_icon.png": 87430,
	"./didi/no_rewards.png": 4540,
	"./didi/not_the_kaesong.png": 58966,
	"./didi/qr_code.png": 6526,
	"./didi/qr_code_bottom.png": 77253,
	"./didi/riderIcon.png": 56132,
	"./didi/shopIcon.png": 43934,
	"./didi/tag_left.png": 79936,
	"./download/download_app_android.png": 46104,
	"./download/download_app_ios.png": 76995,
	"./feed/network.png": 87787,
	"./feed/no-country.png": 31759,
	"./feed/no-result.png": 65405,
	"./feed/no-service.png": 10105,
	"./kaLogo/h5_logo1.png": 56039,
	"./kaLogo/h5_logo2.png": 92757,
	"./kaLogo/h5_logo3.png": 20388,
	"./kaLogo/h5_logo4.png": 25526,
	"./kaLogo/h5_logo5.png": 52507,
	"./kaLogo/h5_logo6.png": 7743,
	"./kaLogo/h5_logo7.png": 65728,
	"./kaLogo/h5_logo8.png": 27335,
	"./kaLogo/pc_logo1.png": 78449,
	"./kaLogo/pc_logo2.png": 35569,
	"./kaLogo/pc_logo3.png": 58135,
	"./kaLogo/pc_logo4.png": 25343,
	"./kaLogo/pc_logo5.png": 13043,
	"./kaLogo/pc_logo6.png": 13611,
	"./kaLogo/pc_logo7.png": 70753,
	"./kaLogo/pc_logo8.png": 96257,
	"./order/cancel/cancel_result.png": 40108,
	"./order/cancel/customer_service.png": 86322,
	"./order/cancel/merchat.png": 9963,
	"./order/cancel/merchat_handling.png": 1010,
	"./order/cancel/rider.png": 24143,
	"./order/feedback/delete.png": 10024,
	"./order/feedback/info.png": 40230,
	"./order/feedback/minus.png": 7515,
	"./order/feedback/minus_disable.png": 74074,
	"./order/feedback/plus.png": 59981,
	"./order/feedback/plus_disable.png": 90818,
	"./order/feedback/refounded.png": 29182,
	"./order/feedback/shopRefused.png": 76100,
	"./order/feedback/waitService.png": 68261,
	"./order/feedback/waitShop.png": 15248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;